import { create } from "zustand";
var useTechnicalStore = create(function (set) { return ({
    setPersonalData: function (personalData) { return set({ personalData: personalData }); },
    setAddressData: function (addressData) { return set({ addressData: addressData }); },
    setSchoolData: function (schoolData) { return set({ schoolData: schoolData }); },
    setLegalRepresentativeData: function (legalRepresentativeData) {
        return set({ legalRepresentativeData: legalRepresentativeData });
    },
    setTermosAndConditions: function (termosAndConditions) { return set({ termosAndConditions: termosAndConditions }); },
    setCategoryAndModalityData: function (categoryAndModalityData) {
        return set({ categoryAndModalityData: categoryAndModalityData });
    },
    setProfessionalData: function (professionalData) { return set({ professionalData: professionalData }); },
    reset: function () {
        return set({
            personalData: undefined,
            addressData: undefined,
            schoolData: undefined,
            legalRepresentativeData: undefined,
            termosAndConditions: undefined,
            categoryAndModalityData: undefined,
            professionalData: undefined,
        });
    },
}); });
export default useTechnicalStore;
